import { render, staticRenderFns } from "./chat-message-actions.vue?vue&type=template&id=85a6c214&scoped=true&"
import script from "./chat-message-actions.vue?vue&type=script&lang=js&"
export * from "./chat-message-actions.vue?vue&type=script&lang=js&"
import style0 from "./chat-message-actions.vue?vue&type=style&index=0&id=85a6c214&lang=sass&scoped=true&"
import style1 from "./chat-message-actions.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a6c214",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VDivider,VList,VListItem,VListItemIcon,VListItemTitle,VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85a6c214')) {
      api.createRecord('85a6c214', component.options)
    } else {
      api.reload('85a6c214', component.options)
    }
    module.hot.accept("./chat-message-actions.vue?vue&type=template&id=85a6c214&scoped=true&", function () {
      api.rerender('85a6c214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/components/chat-message-actions/chat-message-actions.vue"
export default component.exports